 import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, orangeColor, darkSlateGrey, blueColor, DodgerBlueColor, oceanBlueColor} from '../../cmsMainStyle'

const unpublishStyle = theme => ({
	root: {
		width: '100%',
	},


	title: {
		paddingBottom: theme.spacing(1)
	},

	paper: {
		marginBottom: theme.spacing(1)
	},

	messageArea: {
		width: "100%",
		paddingTop: theme.spacing(3),
		textAlign: 'center',
	},





	coverInfo: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		height: theme.spacing(15),
		padding: theme.spacing(1),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},

	coverInfoRow: {
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(0.5),
	},

	coverField: {
		display: "inline"
	},

	coverContent: {
		display: "inline"
	},



	drawingPropertyArea: {
		// paddingTop: theme.spacing(1),
		// paddingbottom: theme.spacing(1)
	},

	content: {
		// display: "flex",
		// alignItems: "center",
		// alignItems: "flexStart",
		textAlign: 'center',
	},

	formControl: {
		// margin: theme.spacing(1),
		minWidth: "100%",
		textAlign: 'left',
	},





	toolMenu: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
	},

	toolMenuBtnGroup: {
		marginTop: theme.spacing(0),
		marginBottom: theme.spacing(1),
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(2),
	},


	toolMenuBtn: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
	},




	menuPaper: {
		minHeight: 10,
		maxHeight: 200,
	},




	alignLeft: {

		
		backgroundColor: "yellow",
		textAlign: 'left',

		// display: "flex",
		// justifyContent: "flex-start"
	},

	alignRight: {

		backgroundColor: "green",
		textAlign: 'right',

		// display: "flex",
		// justifyContent: "flex-end"
	},


	toolMenuBarBtn: {
		
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},


	selectAllDrawingBtn: {
		background: darkSlateGrey[10],
		'&:hover': {
			background: darkSlateGrey[13],
		},
	},

	toolMenuBarBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},
	},

	ToggleButtonGroup: {
		width: "100%"
	},

	ToggleButton: {
		width: "25%",
		"&.Mui-selected": {
			backgroundColor: oceanBlueColor[1]
		}

	},


	// ToggleButtonSelected: {
	// 	backgroundColor: "red"
	// },


	// workaround: {
	// 	color: 'black',
	// 	'&:after': {
	// 	  backgroundColor: 'red',
	// 	},
	// 	'& + &:before': {
	// 	  backgroundColor: 'yellow',
	// 	},
	//   },



	tagBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},

		// textAlign: "left"
		// marginTop: theme.spacing(1),
		// marginLeft: theme.spacing(1),
		// marginRight: theme.spacing(1),
	},

	tagArea: {
		'& > *': {
			marginBottom: theme.spacing(0.5),
		},
    	minHeight: theme.spacing(10),
		padding: theme.spacing(0.5),
		textAlign: "left",
	},


	applyBtnGroup: {
		textAlign: "right"
	},

	applyBtn: {
		// '& > *': {
		// 	marginLeft: theme.spacing(1),
		// 	marginRight: theme.spacing(1),
		// },
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),

		// background: DodgerBlueColor[11],
		background: orangeColor[11],
		'&:hover': {
			background: orangeColor[13],
		},

		// textAlign: "left"
		// marginTop: theme.spacing(1),
		// marginLeft: theme.spacing(1),
		// marginRight: theme.spacing(1),
	},


	coverTypeGrid: {
		textAlign: "left",
	},

	coverTypeArea: {
		width: "100%"
	},


	// detailContent: {

	// 	// height: window.outerHeight - (window.outerHeight - window.innerHeight + 400),
	// 	// overflowY: "auto",
	// 	// overflowX: "hidden",
	// },


	drawingList: {
		// height: "100vh",
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 290),
		overflowY: "auto",
		overflowX: "hidden",
	},

	viewerArea: {
		// height: "100vh",
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 90),
		overflowY: "auto",
		overflowX: "hidden",
	},

	// AccordionFocus: {
	// 	//   margin: theme.spacing(1),
	// 	//   minWidth: 120,
	// 	//   "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
	// 	// 	borderColor: "blue"
	// 	//   }

	// 	// "&.MuiAccordionSummary-root": {
	// 	// 	backgroundColor: "blue"
	// 	// },

	// 	//   "&:focus": {
	// 	// 	backgroundColor: "blue"
	// 	//   }

	// 	// "&$focused": {
	// 	// 	backgroundColor: "blue"
	// 	// }


	// 	"&$expanded": {
	// 		//Elevation 1
  
	// 		// boxShadow:
	// 		//   "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
  
	// 		// minHeight: "0px",
	// 		backgroundColor: "#3f51b5",
	// 		color: "white"
  
	// 		// "& .MuiExpansionPanelSummary-expandIcon": {
	// 		//   color: "white"
	// 		// }
	// 	  }
		

	// 	},

	chips: {
		display: 'flex',
		flexWrap: 'wrap',

		// "&$selected": {
		// 	backgroundColor: "red",
		// }
	},

	chip: {
		margin: 2,
		backgroundColor: oceanBlueColor[8],

		// "&$selected": {
		// 	backgroundColor: "red",
		// }
	},

	// selectMenuItem: {
		
	// 	// "&$selected": {
	// 	// 	backgroundColor: "red",
	// 	// }

	// 	root: {
	// 		"&$selected": {
	// 			backgroundColor: "red",
	// 		}
	// 	}

	// },

	validationErrorMsg: {
		marginTop: "5px",
		marginLeft: "16px",
		textAlign: "left",
	},


	webviewer: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 90)
	},

})


export default unpublishStyle